import { render, staticRenderFns } from "./shipmentsList.vue?vue&type=template&id=5cba49a3&"
import script from "./shipmentsList.vue?vue&type=script&lang=js&"
export * from "./shipmentsList.vue?vue&type=script&lang=js&"
import style0 from "./shipmentsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports